import React from 'react';
import * as XLSX from 'xlsx';

const StringerMain = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const stringerData = inspectionData.stringer;

  if (!stringerData) {
    return <p className="text-gray-500">No Stringer Main data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Stringer',
      'Line',
      'Section',
      'Plate 1',
      'Plate 2',
      'Plate 3',
      'Plate 4',
      'Plate 5',
      'Set Temperature',
      'Welding Time',
      'Remarks',
    ]);

    // Populate data for each stringer and section
    Object.entries(stringerData).forEach(([stringerKey, stringer]) => {
      const { line, sectionA, sectionB } = stringer;

      // Section A
      worksheetData.push([
        stringerKey,
        line,
        'Section A',
        sectionA.heatingPlate.plate1,
        sectionA.heatingPlate.plate2,
        sectionA.heatingPlate.plate3,
        sectionA.heatingPlate.plate4,
        sectionA.heatingPlate.plate5,
        sectionA.setTemperature,
        sectionA.weldingTime,
        sectionA.remarks,
      ]);

      // Section B
      worksheetData.push([
        stringerKey,
        line,
        'Section B',
        sectionB.heatingPlate.plate1,
        sectionB.heatingPlate.plate2,
        sectionB.heatingPlate.plate3,
        sectionB.heatingPlate.plate4,
        sectionB.heatingPlate.plate5,
        sectionB.setTemperature,
        sectionB.weldingTime,
        sectionB.remarks,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'StringerMain');
    XLSX.writeFile(workbook, 'StringerMainData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Stringer Data</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(stringerData).map(([stringerKey, stringer]) => (
        <div key={stringerKey} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            {stringerKey} - Line: {stringer.line}
          </h3>

          {/* Section A */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Section A</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Plate 1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 2</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 3</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 4</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 5</th>
                    <th className="px-4 py-2 text-left text-gray-700">Set Temperature</th>
                    <th className="px-4 py-2 text-left text-gray-700">Welding Time</th>
                    <th className="px-4 py-2 text-left text-gray-700">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.heatingPlate.plate1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.heatingPlate.plate2 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.heatingPlate.plate3 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.heatingPlate.plate4 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.heatingPlate.plate5 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.setTemperature || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.weldingTime || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionA.remarks || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Section B */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Section B</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Plate 1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 2</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 3</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 4</th>
                    <th className="px-4 py-2 text-left text-gray-700">Plate 5</th>
                    <th className="px-4 py-2 text-left text-gray-700">Set Temperature</th>
                    <th className="px-4 py-2 text-left text-gray-700">Welding Time</th>
                    <th className="px-4 py-2 text-left text-gray-700">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.heatingPlate.plate1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.heatingPlate.plate2 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.heatingPlate.plate3 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.heatingPlate.plate4 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.heatingPlate.plate5 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.setTemperature || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.weldingTime || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{stringer.sectionB.remarks || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StringerMain;